// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"415":"2bbc385f","846":"d561d897","964":"6bc16ec7"}[chunkId] + ".chunk.css";
};